<template>
  <q-virtual-scroll
    v-slot="{ item }"
    class="refinement-tree-list"
    :items="items"
  >
    <ListItem
      :key="item.value"
      class="refinement-tree-list--item"
      :class="[item.isRefined && 'is-refined', item.isStale && 'is-stale']"
      clickable
      @click="handleClick(item)"
    >
      <ListSection
        class="checkbox-section"
        side
        top
        @click.stop
      >
        <Checkbox
          :model-value="item.isRefined"
          size="xs"
          @update:model-value="() => refine(item.value)"
        />
      </ListSection>

      <ListSection class="label-section">
        <ListLabel>
          <span class="label-code">{{ item.code }}</span>
          <span
            v-if="item.label !== item.code"
            class="label-name"
          >{{ item.label }}</span>

          <Tooltip v-if="item.isStale">
            {{ t('filters:Filter.atc.noMatch') }}
          </Tooltip>
        </ListLabel>
      </ListSection>

      <ListSection
        class="count-section"
        side
        top
      >
        <Badge
          :label="item.count"
          :color="item.isStale ? 'disabled' : 'primary'"
        />
      </ListSection>

      <ListSection
        v-if="item.children?.length"
        class="chevron-section"
        side
        top
      >
        <q-icon name="mono-chevron-right" />
      </ListSection>

      <Menu
        v-if="item.children?.length"
        v-model="openState[item.value]"
        class="refinement-tree-sub-menu"
        anchor="top left"
        self="top right"
        :offset="[0, 0]"
        :auto-close="false"
        no-parent-event
        no-route-dismiss
      >
        <RefinementTreeList
          :items="item.children"
          :level="level + 1"
          :refine="refine"
        />
      </Menu>
    </ListItem>
  </q-virtual-scroll>
</template>

<script setup>
import { reactive } from 'vue'
import { useTranslation } from 'i18next-vue'
import RefinementTreeList from './RefinementTreeList.vue'

defineOptions({ name: 'RefinementTreeList' })
const props = defineProps({
  items: { type: Array, required: true },
  refine: { type: Function, required: true },
  level: { type: Number, default: 0 }
})

const { t } = useTranslation()
const openState = reactive({})

const handleClick = item => {
  if (item.children?.length) {
    openState[item.value] = !openState[item.value]
  } else {
    props.refine(item.value)
  }
}
</script>

<style>
@reference "#app-styles.css";

.refinement-tree-sub-menu { @apply overflow-visible; }
</style>

<style scoped>
@reference "#app-styles.css";

.refinement-tree-list {
  @apply min-w-70 max-h-80 h-svh overflow-y-auto block;
}

.label-section {
  .list-label {
    @apply flex items-baseline gap-2;

    .label-code { @apply text-xs text-primary-mid font-mono font-medium shrink-0; }
    .label-name { @apply text-xs; }
  }
}

.refinement-tree-list--item.is-stale {
  .label-code,
  .label-name { @apply ink-soft; }
}
</style>
